import React, { useState } from "react";
import DeleteAccountModal from "./modal/DeleteAccountModal";

export default function DeactivateAccount() {
  const [deleteAccountModal, setDeleteAccountModal] = useState(false);
  const cancelModal = () => {
    setDeleteAccountModal(false);
  };
  const [selectedReason, setSelectedReason] = useState("");
  const reasons = [
    "Not satisfied with the service",
    "Found a better alternative",
    "Privacy concerns",
    "Other",
  ];

  const handleReasonChange = (event) => {
    setSelectedReason(event.target.value);
  };

  return (
    <div className="account-deactivation">
      <div className="mx-4">
        <p className="settings-custom-small fw-bold">Account Deactivation</p>
        <p className="text-muted">If you wish to leave Membotic, you can deactivate your account. Simply select your reason for leaving, then press "Deactivate Account."</p>


        <p>I'm leaving because...</p>

        <hr className="dashed w-75" />

        <select value={selectedReason} onChange={handleReasonChange}>
          <option value="" disabled>
            Select a reason
          </option>
          {reasons.map((reason, index) => (
            <option key={index} value={reason}>
              {reason}
            </option>
          ))}
        </select>

        <hr className="dashed w-75" />

        <div className="form-actions">
          <button
            onClick={() => setDeleteAccountModal(true)}
            className="saveChanges-button mb-4"
            type="submit"
            disabled={!selectedReason} // Button is disabled when no reason is selected
          >
            Deactivate Account
          </button>
        </div>
        {deleteAccountModal && <DeleteAccountModal cancelModal={cancelModal} />}
      </div>
    </div>
  );
}
